import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {StoreService} from '../core/common/store/store.service';
import {Configuration} from '../core/common/configuration';


@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

  constructor(private config: Configuration,
              private storeService: StoreService) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      tap(evt => {
        if (evt instanceof HttpResponse && evt.headers) {
          if (evt.headers.get(this.config.HEADER_FIELDS.twoFaRequestCode) &&
            evt.headers.get(this.config.HEADER_FIELDS.twoFaRequestCode) != null &&
            evt.headers.get(this.config.HEADER_FIELDS.twoFaRequestCode) !== this.storeService.getTwoFaRequest()) {
            this.storeService.setTwoFaRequest(evt.headers.get(this.config.HEADER_FIELDS.twoFaRequestCode));
            this.storeService.setTwoFaTimeExpire(evt.headers.get(this.config.HEADER_FIELDS.twoFaTimeExpire));
          }
        }
      }));
  }

}
